import BillingOverview from '@app/features/billing/BillingOverview/BillingOverview';

const BillingOverViewPage = () => {
  return <BillingOverview />;
};

export default BillingOverViewPage;
